import React from "react";
import { Box, makeStyles, Tooltip } from "@material-ui/core";

function getIndicatorValue(indicator, menuIndicators) {
  const group = indicator.group ?? "leave";
  const slice = menuIndicators?.[group];
  if (indicator.keys?.length) {
    return indicator.keys.reduce((sum, k) => sum + Number(slice?.[k] ?? 0), 0);
  }
  return Number(slice?.[indicator.key] ?? 0);
}

function indicatorReactKey(indicator) {
  if (indicator.key != null) return indicator.key;
  if (indicator.keys?.length) return indicator.keys.join(":");
  return indicator.label ?? "";
}

const MenuIndicator = ({ indicators, menuIndicators }) => {
  const classes = useStyles();
  if (!indicators || indicators.length === 0) {
    return null;
  }

  const positive = indicators.filter((indicator) => {
    const value = getIndicatorValue(indicator, menuIndicators);
    return value > 0;
  });

  if (positive.length === 0) {
    return null;
  }

  return (
    <Box display="flex" className={classes.indicators}>
      {positive.map((indicator) => {
        const indicatorValue = getIndicatorValue(indicator, menuIndicators);
        return (
          <Tooltip key={indicatorReactKey(indicator)} title={indicator.label}>
            <Box
              className={classes.indicator}
              style={{
                backgroundColor: indicator.bgColor,
                border: `1px solid ${indicator.textColor}`,
              }}
            >
              <span
                style={{
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  fontFamily: "Mulish",
                  color: indicator.textColor,
                }}
              >
                {indicatorValue}
              </span>
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default React.memo(MenuIndicator);

const useStyles = makeStyles(() => ({
  indicator: {
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "999px",
    minWidth: "22px",
    height: "22px",
    padding: "0 7px",
  },
  indicators: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginLeft: 8,
  },
}));
